import React from 'react';
import { motion } from 'framer-motion';
import { Check, X } from 'lucide-react';
export function WhoThisIsFor() {
  return <section className="py-20 px-6 bg-white" data-id="element-146">
      <div className="max-w-5xl mx-auto" data-id="element-147">
        <h2 className="text-3xl md:text-4xl font-serif text-center text-[#2D2D2D] mb-16" data-id="element-148">
          Is this right for you?
        </h2>

        <div className="grid md:grid-cols-2 gap-8" data-id="element-149">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-[#F5F1E8] p-8 rounded-2xl" data-id="element-150">
            <h3 className="text-xl font-serif font-bold text-[#8B9D83] mb-6" data-id="element-151">
              This IS for you if:
            </h3>
            <ul className="space-y-4" data-id="element-152">
              <li className="flex gap-3" data-id="element-153">
                <Check className="w-5 h-5 text-[#8B9D83] shrink-0 mt-1" data-id="element-154" />
                <span className="text-[#4A4A4A]" data-id="element-155">
                  You're a mom in the U.S. trying to reduce triggers for a
                  sensitive/allergy-prone child
                </span>
              </li>
              <li className="flex gap-3" data-id="element-156">
                <Check className="w-5 h-5 text-[#8B9D83] shrink-0 mt-1" data-id="element-157" />
                <span className="text-[#4A4A4A]" data-id="element-158">
                  You're tired of vague "low-tox" advice that doesn't match real
                  life
                </span>
              </li>
              <li className="flex gap-3" data-id="element-159">
                <Check className="w-5 h-5 text-[#8B9D83] shrink-0 mt-1" data-id="element-160" />
                <span className="text-[#4A4A4A]" data-id="element-161">
                  You want a routine that works even when you're exhausted
                </span>
              </li>
            </ul>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-white border border-[#E5E5E5] p-8 rounded-2xl" data-id="element-162">
            <h3 className="text-xl font-serif font-bold text-[#D4A59A] mb-6" data-id="element-163">
              This is NOT for you if:
            </h3>
            <ul className="space-y-4" data-id="element-164">
              <li className="flex gap-3" data-id="element-165">
                <X className="w-5 h-5 text-[#D4A59A] shrink-0 mt-1" data-id="element-166" />
                <span className="text-[#4A4A4A]" data-id="element-167">
                  You want medical treatment guidance or cure claims
                </span>
              </li>
              <li className="flex gap-3" data-id="element-168">
                <X className="w-5 h-5 text-[#D4A59A] shrink-0 mt-1" data-id="element-169" />
                <span className="text-[#4A4A4A]" data-id="element-170">
                  You want a full-home detox that requires replacing everything
                  at once
                </span>
              </li>
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}